// @core/api/endpoints/userprofile/activate_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateBannerRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Set banner as active
 * Sets the specified banner as the active profile banner. The previously active banner becomes inactive but is not deleted.
 */
export async function ActivateBanner(
  profile_id: string,
  banner_id: string,
  data: ActivateBannerRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/banners/:banner_id/activate`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':banner_id', encodeURIComponent(banner_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
